import { CaseInsensitiveMap } from "./CaseInsensitiveMap";
/*
export interface JasonDB {
    name:       string;
    Comment:    string;
    Components: Component[];
    Attributes: Attribute[];
} */

export interface Attribute {
    SKU:        string;
    tag:        string;
    tagValue:   string;
    group:      string;
    groupValue: string;
}

export interface Component {
    name:  string;
    group: string;
    tags:   Tag[];
}

export interface Tag {
    name:    string;
    default: string;
}


export class JsonDB {

    public DefaultMaterialTag:CaseInsensitiveMap<string>  = new CaseInsensitiveMap();
    public MaterialTag:CaseInsensitiveMap<string[]>  = new CaseInsensitiveMap();
    public Attributes:Attribute[] = [];
    //public Groups:CaseInsensitiveMap<Set<string>> = new CaseInsensitiveMap();
    public Groups:CaseInsensitiveMap<string> = new CaseInsensitiveMap();
    constructor()
    {
    }
    public async ReadJson(Json: string)
    {
        console.log(Json);

        var request = await fetch(Json);
        var data = await request.json();

        const components:Component[] = data.Component ?? data.Components ?? [];
        for (const component of components) {

            if (component.group)
            {

                this.Groups.set(component.name, component.group);
                // let models = this.Groups.get(component.group);
                // if (models)
                //     models.add(component.name);
                // else
                // {
                //     models = new Set<string>();
                //     models.add(component.name);
                //     this.Groups.set(component.group, models);
                // }
            }

            const tags = (component as any).tag ?? component.tags ?? [];
            for (const tag of tags) {
                this.MaterialTag.set(tag.name, tag.materials ?? []);
                this.DefaultMaterialTag.set(tag.name, tag.default);
            }
        }

        const attributes = data.Attributes ?? [];
        for (const attribute of attributes) {
            this.Attributes.push(attribute);
            console.log(attribute)
        }

        // for(let i=0;i<data.Component.length;i++)
        // {
        //     for(let j=0;j<data.Component[i].tag.length;j++)
        //     {
        //         this.MaterialTag.set(data.Component[i].tag[j].name,data.Component[i].tag[j].materials)
        //         this.DefaultMaterialTag.set(data.Component[i].tag[j].name,data.Component[i].tag[j].default)
        //     }
        // }
    }
    
}